<template>
    <div class="widget-trustindex-skeleton">
        <div class="widget-trustindex-skeleton__content" :class="theme" />
    </div>
</template>

<script>
export default {
    name: 'SkeletonWidget',
    props: {
        theme: {
            type: String,
            default: 'light'
        }
    }
}
</script>

<style scoped>
.widget-trustindex-skeleton {
    position: relative;
    background: #FFFFFF;
    border-radius: 5px;
}

.widget-trustindex-skeleton__content {
    width: 100%;
    height: 100%;
    opacity: 0.5;
    border-radius: 5px;
    animation: diagonal-shimmer 1.6s infinite linear;
}

.widget-trustindex-skeleton__content.light {
    background: linear-gradient(
        120deg,
        #54B600 30%, 
        #5ec801 50%, 
        #54B600 70%
    );
    background-size: 300% 300%;
}

.widget-trustindex-skeleton__content.dark {
    background: linear-gradient(
        120deg,
        #ccfaa7 30%, 
        #b0f975 50%, 
        #ccfaa7 70%
    );
    background-size: 300% 300%;
}

@keyframes diagonal-shimmer {
    0% {
        background-position: 100% 100%;
    }
    100% {
        background-position: 0% 0%;
    }
}
</style>